import * as React from 'react';
import { useId } from 'react';
import { cn } from '@/lib/utils';

interface FloatingFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label: string;
  error?: string | undefined;
}

export const FloatingField = React.forwardRef<HTMLInputElement, FloatingFieldProps>(
  ({ label, error, className, ...props }, ref) => {
    const id = useId();
    return (
      <div className="w-full">
        {/* Label: mono 10px uppercase tracking (igual ao protótipo) */}
        <label
          htmlFor={id}
          className="block mb-2 font-mono text-[12px] uppercase tracking-wider text-muted-foreground"
        >
          {label}
        </label>
        <input
          id={id}
          ref={ref}
          className={cn(
            // text-base (16px) evita zoom no iOS; foco escurece a borda
            'w-full rounded-lg border bg-card px-3.5 py-3 text-base text-foreground outline-none transition-colors focus:border-foreground',
            error ? 'border-destructive' : 'border-border',
            className,
          )}
          {...props}
        />
        {error && <p className="text-destructive text-xs mt-1.5">{error}</p>}
      </div>
    );
  },
);
FloatingField.displayName = 'FloatingField';

interface FloatingTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string | undefined;
}

export const FloatingTextarea = React.forwardRef<HTMLTextAreaElement, FloatingTextareaProps>(
  ({ label, error, className, ...props }, ref) => {
    const id = useId();
    return (
      <div className="w-full">
        <label
          htmlFor={id}
          className="block mb-2 font-mono text-[12px] uppercase tracking-wider text-muted-foreground"
        >
          {label}
        </label>
        <textarea
          id={id}
          ref={ref}
          rows={3}
          className={cn(
            'w-full rounded-lg border bg-card px-3.5 py-3 text-base text-foreground outline-none transition-colors focus:border-foreground resize-y leading-snug',
            error ? 'border-destructive' : 'border-border',
            className,
          )}
          {...props}
        />
        {error && <p className="text-destructive text-xs mt-1.5">{error}</p>}
      </div>
    );
  },
);
FloatingTextarea.displayName = 'FloatingTextarea';
